import React from "react";
import * as ReactBootStrap from "react-bootstrap";
import { BrowserRouter as Router, Link } from "react-router-dom";
import { BrowserRouter } from "react-router-dom/cjs/react-router-dom.min";
import Home from "../home/Home";
import "./NavBar.css";

function logout() {
  sessionStorage.clear();
  window.location = "/";
}

const NavBar = () => {
  if (sessionStorage.getItem("token")) {
    return (
      <div className="App">
        <ReactBootStrap.Navbar
          collapseOnSelect
          expand="xl"
          bg="danger"
          variant="dark"
        >
          <ReactBootStrap.Navbar.Collapse id="responsive-navbar-nav">
            <ReactBootStrap.Nav>
              <Link class="nav-links" to="/">
                <ReactBootStrap.Nav.Link class="nav-links" href="#home">
                  Home
                </ReactBootStrap.Nav.Link>
              </Link>
            </ReactBootStrap.Nav>
            <ReactBootStrap.Nav>
              <Link class="nav-links" to="/members">
                <ReactBootStrap.Nav.Link class="nav-links" href="#members">
                  Members
                </ReactBootStrap.Nav.Link>
              </Link>
            </ReactBootStrap.Nav>
            <ReactBootStrap.Nav>
              <Link class="nav-links" to="/products">
                <ReactBootStrap.Nav.Link class="nav-links" href="#products">
                  Products
                </ReactBootStrap.Nav.Link>
              </Link>
            </ReactBootStrap.Nav>
            <ReactBootStrap.Nav>
              <Link class="nav-links" to="/rent-requests">
                <ReactBootStrap.Nav.Link
                  class="nav-links"
                  href="#rent-requests"
                >
                  Rent Requests
                </ReactBootStrap.Nav.Link>
              </Link>
            </ReactBootStrap.Nav>
            <button onClick={logout}> Logout </button>
          </ReactBootStrap.Navbar.Collapse>
        </ReactBootStrap.Navbar>
      </div>
    );
  } else {
    return Home;
  }
};

export default NavBar;
